import React, { useEffect, useState } from 'react';
import { getApiBaseUrl } from "../utils/apiAssetUrl";
import { formatBookingDateForDisplay } from "../utils/formatBookingDate";
import { Link, useNavigate } from 'react-router-dom';
import '../CSS/Global.css';
import Header from '../Components/Header';
import CryptoJS from 'crypto-js'; // For decryption
import orderimg from "../Images/noorder.jpg"

const NewOrder = () => {
    const [filter, setFilter] = useState('all-order');
    const [isModalOpen, setModalOpen] = useState(false);
    const [modalOrderId, setModalOrderId] = useState(null);
    const [isCancelModalOpen, setCancelModalOpen] = useState(false);
    const url = getApiBaseUrl()

    // Orders data
    // const orders = [
    //     {
    //         id: '12345678',
    //         date: '28 Nov 2024',
    //         status: 'active',
    //         items: ['Item 1', 'Item 2'],
    //         total: 1810,
    //         orderedBy: 'Thakur Singh',
    //     },
    //     {
    //         id: '12345679',
    //         date: '28 Nov 2024',
    //         status: 'delivered',
    //         items: ['Item 1', 'Item 2'],
    //         total: 1810,
    //         orderedBy: 'Thakur Singh',
    //     },
    //     {
    //         id: '12345680',
    //         date: '28 Nov 2024',
    //         status: 'returned',
    //         items: ['Item 1', 'Item 2'],
    //         total: 1810,
    //         orderedBy: 'Thakur Singh',
    //     },
    //     {
    //         id: '12345681',
    //         date: '28 Nov 2024',
    //         status: 'cancelled',
    //         items: ['Item 1', 'Item 2'],
    //         total: 1810,
    //         orderedBy: 'Thakur Singh',
    //     },
    // ];


    let navigate = useNavigate()
    const [currentPage, setCurrentPage] = useState(1);
    let login = JSON.parse(localStorage.getItem("login")) || "";
    let [order, setOrder] = useState([]);

    const decrypt = (encryptedData, iv) => {
        const key = 'ThisIsA32CharacterLongKey123456!'; // 32-character key used on the backend

        // Convert key, IV, and encrypted data to appropriate CryptoJS formats
        const keyHex = CryptoJS.enc.Utf8.parse(key);  // Convert the key to a CryptoJS format
        const ivHex = CryptoJS.enc.Hex.parse(iv);     // Convert IV from 'hex'

        // Decrypt the data using AES with CBC mode
        const decrypted = CryptoJS.AES.decrypt({ ciphertext: CryptoJS.enc.Hex.parse(encryptedData) }, keyHex, {
            iv: ivHex,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });

        // Return the decrypted UTF-8 string
        return decrypted.toString(CryptoJS.enc.Utf8);
    };

    let fetchOrderData = async () => {
        try {
            let response = await fetch(`${url}/pay-all/store/${login.permanent_ID}`)
            let res = await response.json();
            console.log(res.data);
            const decryptedData = decrypt(res.data.data, res.data.iv);
            console.log(decryptedData)
            if (decryptedData) {
                const parsedData = JSON.parse(decryptedData);
                const parsedOrders = parsedData.map((order) => ({
                    ...order,
                    product: typeof order.product === 'string' ? JSON.parse(order.product) : (order.product || order.cart_product || []),
                    user_address: typeof order.user_address === 'string' ? JSON.parse(order.user_address) : (order.user_address || {}),
                    vendor_address: typeof order.vendor_address === 'string' ? JSON.parse(order.vendor_address) : (order.vendor_address || {}),
                }));
                setOrder(parsedOrders.reverse());

                // Check if any object's status is 'paid'

            } else {
                console.error("Decrypted data is empty or invalid");
            }

        } catch (error) {
            console.log(error);
        }
    }


    const handleChange = async (Change) => {
        try {
            let response = await fetch(`${url}/pay-all/${modalOrderId}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ status: Change })
            })
            if (response.ok) {
                let res = await response.json()
                console.log(res);
                setOrder(prevData => prevData.map(order => {
                    if (order.transaction_id === modalOrderId) {
                        return { ...order, status: Change }; // Update the orderStatus of the specific order
                    }
                    return order;
                }));
                setCancelModalOpen(false)

            }
        } catch (error) {
            console.log(error)
        }
    }

    const userPerPage = 5;
    const lastIndex = currentPage * userPerPage;
    const firstIndex = lastIndex - userPerPage;
    const user = order.slice(firstIndex, lastIndex);
    const totalPages = Math.ceil(order.length / userPerPage);
    useEffect(() => {
        fetchOrderData();
    }, [])
    console.log(order);
    // Filter logic
    const renderOrder = (order) => {
        const statusLower = order.status?.toLowerCase?.() || '';
        const filterMatch = filter === 'all-order' || statusLower === filter?.toLowerCase?.();
        if (filterMatch) {
            const bookedForLabel = formatBookingDateForDisplay(order.booking_date);
            return (
                <div className="vendor-order-card" key={order.id || order.transaction_id}>
                    <div className="vendor-order-card-header">
                        <div className="vendor-order-card-id">
                            <span className="vendor-order-card-label">Booking #</span>
                            <span className="vendor-order-card-value">{order.transaction_id}</span>
                        </div>
                        <div className="vendor-order-card-status">
                            <span className={`vendor-order-badge vendor-order-badge--${order.status.toLowerCase()}`}>
                                {order.status.charAt(0).toUpperCase() + order.status.slice(1)}
                            </span>
                        </div>
                    </div>
                    <div className="vendor-order-card-dates">
                        <span className="vendor-order-date">
                            <i className="fa-regular fa-calendar"></i> Ordered: {new Date(order.createdAt).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}
                        </span>
                        {bookedForLabel && (
                            <span className="vendor-order-date vendor-order-date--highlight">
                                <i className="fa-regular fa-calendar-check"></i> Booked for: {bookedForLabel}
                            </span>
                        )}
                    </div>
                    <div className="vendor-order-card-items">
                        <h4 className="vendor-order-items-title">Items</h4>
                        {order.product && order.product.map((item, i) => (
                            <div key={i} className="vendor-order-item">
                                <div className="vendor-order-item-info">
                                    <span className="vendor-order-item-name">{item.product?.product_name}</span>
                                    <span className="vendor-order-item-meta">Qty: {item.quantity} × ₹{item.product?.sell_price?.toFixed(2)}</span>
                                </div>
                                <span className="vendor-order-item-price">₹{(item.quantity * (item.product?.sell_price || 0)).toFixed(2)}</span>
                            </div>
                        ))}
                    </div>
                    <div className="vendor-order-card-footer">
                        <div className="vendor-order-card-customer">
                            <i className="fa-regular fa-user"></i>
                            <span>Booked by <strong>{order.user_address?.name || 'N/A'}</strong></span>
                        </div>
                        <div className="vendor-order-card-actions">
                            <div className="vendor-order-total">
                                <span className="vendor-order-total-label">Total</span>
                                <span className="vendor-order-total-amount">₹{(order.amount_p || 0).toFixed(2)}</span>
                            </div>
                            <div className="vendor-order-buttons">
                                {statusLower === 'pending' && (
                                    <button
                                        className="vendor-order-btn vendor-order-btn--cancel"
                                        onClick={() => {
                                            setCancelModalOpen(true);
                                            setModalOrderId(order.transaction_id);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                )}
                                <button
                                    className="vendor-order-btn vendor-order-btn--primary"
                                    onClick={() => navigate(`/vendortrack/${order.transaction_id}`)}
                                >
                                    View timeline
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        return null;
    };


    const handleCancelOrder = () => {
        console.log(`Order ${modalOrderId} canceled.`);
        setCancelModalOpen(false);
    };

    return (
        <>
            <Header />
            <div className="new-orders vendor-order-page">
                <div className="new-order-container vendor-order-container">
                    <div className="vendor-order-header">
                        <h1 className="vendor-order-title">Bookings & Projects</h1>
                        <div className="order-dropdown vendor-order-filter">
                            <select
                                name="order-select"
                                id="order-select"
                                value={filter}
                                onChange={(e) => setFilter(e.target.value)}
                            >
                                <option value="all-order">All Bookings / Projects</option>
                                <option value="Pending">Active</option>
                                <option value="Cancelled">Cancelled</option>
                                <option value="Delivered">Delivered</option>
                            </select>
                        </div>
                    </div>
                    <div className="vendor-order-list">
                        {order.length > 0 ? (
                            order.map(renderOrder)
                        ) : (
                            <div className="vendor-order-empty">
                                <img className="vendor-order-empty-img" src={orderimg} alt="No bookings yet" />
                                <p className="vendor-order-empty-text">No bookings or projects yet</p>
                                <p className="vendor-order-empty-sub">Your booking history will appear here</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Dispatch Modal */}
            {isModalOpen && (
                <div className="track-overlay">
                    <div className="track-overlay-container">
                        <p>Are you sure you want to dispatch the item?<br /> Once dispatched, it cannot be canceled.</p>
                        <div className="track-actions">
                            <button className="cancel-btn" onClick={() => setModalOpen(false)}>Cancel</button>
                            <button className="dispatch-btn" onClick={() => handleChange("Dispatch")}>Yes, Dispatch</button>
                        </div>
                    </div>
                </div>
            )}

            {/* Cancel Order Modal */}
            {isCancelModalOpen && (
                <div className="track-overlay">
                    <div className="track-overlay-container">
                        <p>Are you sure you want to cancel the order?<br /> This action cannot be undone.</p>
                        <div className="track-actions">
                            <button className="cancel-btn" onClick={() => setCancelModalOpen(false)}>Cancel</button>
                            <button className="dispatch-btn" onClick={() => handleChange("Cancelled")}>Yes, Cancel</button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default NewOrder;
